/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ImagesTab from './ImagesTab/index'
import React from 'react'
import ToothChartTab from './ToothChartTab/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/Tabs"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Tabs.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-brpv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<ImagesTab
  viewPath={`${viewPath}/ImagesTab`}
/>
<ToothChartTab
  viewPath={`${viewPath}/ToothChartTab`}
/>
</div>
{children}
</React.Fragment>)
}